<template>
  <div>
    <h3>Payment Summary</h3>
    <el-row :gutter="30" type="flex" align="middle">
      <el-col :span="18">
        <span class="description">
          All payments taken through a membership, event or competition will be grouped and totalled in this report.
        </span>
      </el-col>
      <el-col :span="6" class="d-flex flex-justify-end">
        <!-- <el-button type="primary" icon="el-icon-download" @click="sendReport()">Download</el-button> -->
        <el-button type="primary" icon="el-icon-download" @click="sendReportLambda">Download</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-form
      label-position="top"
      :model="filters"
      :rules="filterRules"
      ref="filters"
      class="login-form"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="dateType">
            <el-radio-group v-model="filters.dateType" @change="setSelectedDateType">
              <el-radio
                v-for="s in dateTypes"
                :key="s.value"
                :label="s.value"
              >{{ s.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="filters.dateType==='season'">
        <el-col :span="8">
          <el-form-item prop="season" label="Season">
            <el-select v-model="filters.season" style="width: 100%">
              <el-option
                v-for="s in seasons"
                :key="s.value"
                :label="s.value"
                :value="s.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-else-if="filters.dateType==='date-range'">
        <el-col :span="16">
          <el-form-item
            prop="dates"
            label="Date Range"
          >
            <el-date-picker
              type="daterange"
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              v-model="filters.dates"
              placeholder=""
              value-format="timestamp"
              :format="timedateObj().formDateFormat"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="entityType" label="Events, Memberships, Competitions">
            <el-select
              v-model="filters.entityType"
              placeholder="Select entity"
              @change="changeEntity"
            >
              <el-option
                v-for="entity in entities"
                :label="entity.name"
                :key="entity.name"
                :value="entity.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="entity" label="Hierarchy">
            <el-select v-model="filters.selectedEntity" style="width: 100%" multiple @change="onChangeEntityLevel">
              <el-option
                v-for="s in levelOptions"
                :key="s.value"
                :label="s.label"
                :value="s.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="level" label="Entity">
            <el-select v-model="filters.orgtreeEntityIds" style="width: 100%" multiple
              filterable>
              <el-option
                v-for="s in uniqOrganisations"
                :key="s._id"
                :label="s.label"
                :value="s._id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="filters.entityType === 'events'">
        <el-col :span="16">
          <el-form-item :prop="getProps('events', 'entityIds')" label="Event">
            <el-button type="text" @click="toggleSelectAllEntities('entity')">{{ get(filters,'entityIds').length ? 'Deselect All' : 'Select All' }}</el-button>
            <el-select
              filterable
              v-model="filters.entityIds"
              placeholder="Select Event"
              multiple
            >
              <el-option
                v-for="event in filteredSelections"
                :label="`${event.name} - ${getEntityNameandID(event)}`"
                :key="event._id"
                :value="event._id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="filters.entityType === 'memberships'">
        <el-col :span="16">
          <el-form-item :prop="getProps('memberships', 'entityIds')" label="Membership">
            <el-button type="text" @click="toggleSelectAllEntities('entity')">{{ get(filters,'entityIds').length ? 'Deselect All' : 'Select All' }}</el-button>
            <el-select
              v-model="filters.entityIds"
              filterable
              placeholder="Select Membership"
              multiple
            >
              <el-option
                v-for="membership in filteredSelections"
                :label="`${membership.name} - ${getEntityNameandID(membership)}`"
                :key="membership._id"
                :value="membership._id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="filters.entityType === 'competitions'">
        <el-col :span="16">
          <el-form-item :prop="getProps('competitions', 'compIds')" label="Competition">
            <el-button type="text" @click="toggleSelectAllEntities('comp')">{{ get(filters,'compIds').length ? 'Deselect All' : 'Select All' }}</el-button>
            <el-select
              v-model="filters.compIds"
            filterable
              placeholder="Select Competition"
              multiple
            >
              <el-option
                v-for="comp in filteredSelections"
                :label="`${comp.name} - ${getEntityNameandID(comp)}`"
                :key="comp._id"
                :value="comp._id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="filters.entityType === 'all'">
        <el-col :span="16">
          <el-form-item :prop="getProps('all', 'entityIds')" label="Entities">
            <el-button type="text" @click="toggleSelectAllEntities('entity')">{{ get(filters,'entityIds').length ? 'Deselect All' : 'Select All' }}</el-button>
            <el-select
              v-model="filters.entityIds"
              filterable
              placeholder="Select Entity"
              multiple
            >
              <el-option
                v-for="entity in selections"
                :label="`${entity.name} - ${getEntityNameandID(entity)}`"
                :key="entity._id"
                :value="entity._id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="filters.entityType === 'all'">
        <el-col :span="16">
          <el-form-item :prop="getProps('all', 'compIds')" label="Competitions">
            <el-button type="text" @click="toggleSelectAllEntities('comp')">{{ get(filters,'compIds').length ? 'Deselect All' : 'Select All' }}</el-button>
            <el-select
              v-model="filters.compIds"
              filterable
              placeholder="Select Competition"
              multiple
            >
              <el-option
                v-for="comp in competitions"
                :label="`${comp.name} - ${getEntityNameandID(comp)}`"
                :key="comp._id"
                :value="comp._id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item prop="fileType" label="File Type">
            <el-select
              v-model="filters.fileType"
              placeholder="Select a file type"
            >
              <el-option
                v-for="fileType in fileTypes"
                :label="fileType.name"
                :key="fileType.type"
                :value="fileType.type"
                :default="fileType.default"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="24">
        <h4>Report Fields</h4>
        <div class="field-selector-container">
          <div class="field-list">
              <el-tag
                v-for="field in availableFields"
                :key="field"
                size="small"
                type='primary'
              >
                {{ field }}
              </el-tag>
            </div>
          </div>
      </el-col>
    </el-form>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment-timezone';
import { timedate } from '@/utils/timedate';
import { errormsg } from '../../../../utils/constants';

export default {
  data() {
    return {
      seasons: this.$store.getters['season/seasons'],
      entities: [
        {
          name: 'All', value: 'all'
        },
        {
          name: 'Events', value: 'events'
        },
        {
          name: 'Memberships', value: 'memberships'
        },
        {
          name: 'Competitions', value: 'competitions'
        }
      ],
      orgnisations: [],
      selections: [],
      get: _.get,
      competitions: [],
      filters: {
        selectedEntity: [],
        fileType: 'csv',
        season: undefined,
        dates: undefined,
        dateType: 'season',
        entityIds: [],
        orgtreeEntityIds: [],
        compIds: [],
        entityType: undefined,
        selectedEntityLevels: [],
      },
      filterRules: {
        entityType: {
          required: true,
          message: errormsg.select_option,
          trigger: 'change',
        },
        // entityIds: {
        //   required: true,
        //   message: errormsg.select_option,
        //   trigger: 'change',
        // },
        // compIds: {
        //   required: true,
        //   message: errormsg.select_option,
        //   trigger: 'change',
        // },
        fileType: {
          required: true,
          message: errormsg.select_option,
          trigger: 'blur',
        },
        dateType: {
          required: true,
          message: errormsg.select_option,
          trigger: 'blur',
        }
      },
      fileTypes: [
        { name: 'CSV', type: 'csv', default: true }
      ],
      dateTypes: [
        { label: 'Season', value: 'season' },
        { label: 'Date Range', value: 'date-range' }
      ],
      availableFields: [
        'Registration Entity Name',
        'Registration Entity Type',
        'Registration Entity ID',
        'Entity Type',
        'Entity Name',
        'Registration ID',
        'Date Range From',
        'Date Range To',
        'Total charged',
        'Product Fee',
        'Fee Withheld',
        'Amount Refunded',
      ],
    };
  },
  computed: {
    filteredSelections() {
      return this.selections.filter((sel) => this.filters.orgtreeEntityIds.includes(sel.entityId));
    },
    uniqOrganisations() {
      return _.uniqBy(this.orgnisations, '_id');
    },
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    currentSeason() {
      return this.$store.getters['season/currentSeason'];
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    },
    entityLevels() {
      return this.$store.getters['user/entityLevels'];
    },
    levelOptions() {
      return [
        { label: 'All', value: 'all' },
        ...this.entityLevels,
      ];
    },
  },
  async mounted() {
    this.filters.season = this.currentSeason;
  },
  methods: {
    async onChangeEntityLevel(val) {
      this.orgnisations = [];
      if (val.includes('all')) {
        this.filters.selectedEntityLevels = this.entityLevels.map((option) => option.value);
        this.filters.selectedEntity = this.entityLevels.map((option) => option.value);
      } else {
        this.filters.selectedEntityLevels = val;
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const e of this.filters.selectedEntity) {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.$http.get(`/assemble/api/v1/admin/${e}s`);
        const entityLevels = res.data.data ? res.data.data.map((entity) => ({ _id: entity._id, name: entity.name, label: entity.name })) : [];
        this.orgnisations = [...this.orgnisations, ...entityLevels];
      }
    },
    toggleSelectAllEntities(type) {
      if (type === 'comp') {
        if (this.filters.compIds.length) this.filters.compIds = [];
        else {
          const compIds = this.competitions.map((comp) => comp._id);
          this.filters.compIds = compIds;
        }
      } else if (this.filters.entityIds.length) this.filters.entityIds = [];
      else {
        const entityIds = this.selections.map((sel) => sel._id);
        this.filters.entityIds = entityIds;
      }
    },
    getEntityNameandID(row) {
      if (_.has(row.orgtree, 'club')) return `${_.get(row, 'orgtree.club.name')} ${_.get(row, 'orgtree.club._id')}`;
      if (_.has(row.orgtree, 'association')) return `${_.get(row, 'orgtree.association.name')} ${_.get(row, 'orgtree.association._id')}`;
      if (_.has(row.orgtree, 'state')) return `${_.get(row, 'orgtree.state.name')} ${_.get(row, 'orgtree.state._id')}`;
      return `${_.get(row, 'orgtree.national.name')} ${_.get(row, 'orgtree.national._id')}`;
    },
    async changeEntity(entity) {
      console.log(entity);
      this.filters.entityIds = [];
      this.$store.commit('loading', true);
      if (entity === 'events') {
        const events = await this.$http.get('/assemble/api/v1/admin/events');
        this.selections = events.data.data;
      } else if (entity === 'memberships') {
        const memberships = await this.$http.get('/assemble/api/v1/admin/memberships');
        this.selections = memberships.data.data;
      } else if (entity === 'competitions') {
        const competitions = await this.$http.get('/assemble/api/v1/admin/competitions');
        this.selections = competitions.data.data;
      } else if (entity === 'all') {
        const events = await this.$http.get('/assemble/api/v1/admin/events');
        const memberships = await this.$http.get('/assemble/api/v1/admin/memberships');
        const competitions = await this.$http.get('/assemble/api/v1/admin/competitions');

        const selections = [...events.data.data, ...memberships.data.data];
        this.competitions = competitions.data.data;
        this.selections = selections;
      }

      this.$store.commit('loading', false);
    },
    timedateObj() {
      return timedate;
    },
    setSelectedDateType() {
      if (this.filters.dateType === 'date-range') this.filters.season = undefined;
      else this.filters.dates = undefined;
    },
    // sendReport() {
    //   this.$refs.filters.validate((valid) => {
    //     if (valid) {
    //       this.$store.commit('loading', true);
    //       const body = {
    //         reportType: 'refunds',
    //         fileType: this.filters.fileType,
    //         filters: {
    //           season: this.filters.season,
    //           fromDate: _.get(this.filters, 'dates[0]'),
    //           toDate: _.get(this.filters, 'dates[1]'),
    //           dateType: this.filters.dateType
    //         },
    //         meta: {
    //           timezone: moment.tz.guess(),
    //         }
    //       };
    //       const url = '/assemble/api/v1/admin/reports';
    //       this.$http
    //         .post(url, body)
    //         .then((response) => {
    //           this.$store.commit('loading', false);
    //           this.$message(response.data.message);
    //         })
    //         .catch(() => {
    //           this.$store.commit('loading', false);
    //           this.$message.error();
    //         });
    //     } else {
    //       return false;
    //     }
    //     return true;
    //   });
    // },
    sendReportLambda() {
      this.$refs.filters.validate((valid) => {
        if (valid) {
          if (this.competitions.length && !this.filters.compIds.length && this.filters.entityType === 'all') {
            return this.$message.error('Please select competition to download report');
            // return false;
          }
          if (this.selections.length && !this.filters.compIds.length && this.filters.entityType === 'competitions') {
            return this.$message.error('Please select competition to download report');
            // return false;
          }
          if (this.selections.length && !this.filters.entityIds.length && this.filters.entityType === 'events') {
            return this.$message.error('Please select event to download report');
            // return false;
          }
          if (this.selections.length && !this.filters.entityIds.length && this.filters.entityType === 'memberships') {
            return this.$message.error('Please select membership to download report');
            // return false;
          }
          this.$store.commit('loading', true);
          const body = {

            reportType: 'payment-summary',
            fileType: this.filters.fileType,
            filters: {
              season: this.filters.season,
              fromDate: _.get(this.filters, 'dates[0]'),
              toDate: _.get(this.filters, 'dates[1]'),
              dateType: this.filters.dateType,
              entityIds: this.filters.entityIds,
              compIds: this.filters.compIds,
              entity: this.filters.entityType
            },
            meta: {
              timezone: this.timezone,
            }
          };
          const url = '/assemble/api/v1/admin/reports-lambda';
          this.$http
            .post(url, body)
            .then((response) => {
              this.$store.commit('loading', false);
              this.$message(response.data.message);
            })
            .catch(() => {
              this.$store.commit('loading', false);
              this.$message.error();
            });
        } else {
          return false;
        }
        return true;
      });
    },
    getProps(type, props) {
      if (type === 'all') return props;
      return this.filters.entityType === type ? props : '';
    },
  },
  watch: {
    'filters.entityType': {
      handler(val) {

      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
